import { ProfileFindDto, type ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import { SaasDtoKeysEnum } from '@zaoblako/shared/modules/saas/enums/saas-dto-keys.enum';
import type { FrmInstanceFindInterface } from '@zaoblako/shared/modules/saas/dtos/frm-instance/frm-instance-find.dto';

import * as yup from 'yup';

/** {@link https://speech2text.ru "Speech2Text"} service account response body - DTO signature */
export interface Speech2TextRuAccountFindInterface {
  /** Unique identifier (UUID). Cannot be changed. */
  id: string;

  // Tech columns
  /** Account creation date and time */
  created: Date;
  /** Account last update date and time */
  updated: Date;
  /** Account soft delete date and time */
  deleted?: Date;

  // Data columns
  /** Account display name */
  name: string;
  /** Account API auth key */
  apiKey: string;
  /** If `true` then this account will be used by default */
  isDefault?: boolean;
  /** Account creator */
  createdBy?: ProfileFindInterface;
  /** FRM instances using this account */
  frmInstances?: FrmInstanceFindInterface[];
}

/** {@link https://speech2text.ru "Speech2Text"} service account response body - DTO schema */
export const Speech2TextRuAccountFindDto = SerdeDtoClass.create<Speech2TextRuAccountFindInterface>(
  IntergrationDtoKeyEnum.SPEECH_2_TEXT_RU_ACCOUNT_FIND_DTO,
  {
    id: {
      label: 'Номер',
      serializer: yup.string(),
    },
    created: {
      sortable: true,
      label: 'Создан',
      serializer: yup.date(),
    },
    updated: {
      label: 'Изменен',
      serializer: yup.date(),
    },
    deleted: {
      optional: true,
      label: 'Удален',
      serializer: yup.date(),
    },
    name: {
      sortable: true,
      label: 'Название аккаунта в интерфейсе',
      serializer: yup.string(),
    },
    apiKey: {
      label: 'Ключ API',
      serializer: yup.string(),
    },
    isDefault: {
      optional: true,
      label: 'По-умолчанию',
      hint: 'Если данный флаг включен, то этот аккаунт будет использоваться по-умолчанию, если не задан другой аккаунт',
      serializer: yup.boolean(),
    },
    createdBy: {
      sortable: true,
      optional: true,
      label: 'Автор',
      nested: ProfileFindDto,
      serializer: (_, nested) => nested,
    },
    frmInstances: {
      optional: true,
      label: 'Инстансы ФРМ, использующие этот аккаунт',
      nested: SaasDtoKeysEnum.FRM_INSTANCE_FIND_DTO,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
